export default "__VITE_ASSET__9431b500__"